var map = {
	"./tab-about-on.svg": "56d5",
	"./tab-about.svg": "a2d2",
	"./tab-active-bar.svg": "eff8",
	"./tab-jobs-on.svg": "56f8",
	"./tab-jobs.svg": "33b5",
	"./tab-qa-on.svg": "6bb2",
	"./tab-qa.svg": "06cc",
	"./tab-steps-on.svg": "e1779",
	"./tab-steps.svg": "b0c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec39";